<template>
  <div class="carousel">
    <!-- Used for transitions  (THIS IS THE SECRET SAUCE FOR THE ANIMATIONS) -->
    <transition-group
      class="image-container"
      v-touch:start.stop="setStartPosition"
      v-touch:end="setEndPosition"
      v-touch:moving="touchMovingHandler"
    >
      <div :key="-3 + offset" class="offscreen">
        <img
          :src="getImage(-3 + offset)"
          :style="imageStyles[0]"
          :class="transitionClass"
          draggable="false"
        />
      </div>
      <div :key="-2 + offset" class="edge" @click="enterFullscreen(-2)">
        <img
          :src="getImage(-2 + offset)"
          :style="imageStyles[1]"
          :class="transitionClass"
          draggable="false"
        />
        <div :class="concept" style="font-size: 1vw" v-if="isConcept(-2 + offset)">[CONCEPT ART]</div>
      </div>
      <div :key="-1 + offset" class="center-edge" @click="enterFullscreen(-1)">
        <img
          :src="getImage(-1 + offset)"
          :style="imageStyles[2]"
          :class="transitionClass"
          draggable="false"
        />
        <div :class="concept" style="font-size: 1.5vw" v-if="isConcept(-1 + offset)">[CONCEPT ART]</div>
      </div>
      <div
        :key="0 + offset"
        class="center"
        @mouseover="setHover(true)"
        @mouseleave="setHover(false)"
        @click="enterFullscreen(0)"
      >
        <img
          :src="getImage(0 + offset)"
          :class="hoverClass"
          :style="imageStyles[3]"
          draggable="false"
        />
        <div :class="concept" style="font-size:2vw" v-if="isConcept(0 + offset)">[CONCEPT ART]</div>
      </div>
      <div :key="1 + offset" class="center-edge" @click="enterFullscreen(1)">
        <img
          :src="getImage(1 + offset)"
          :style="imageStyles[4]"
          :class="transitionClass"
          draggable="false"
        />
        <div :class="concept" style="font-size:1.5vw" v-if="isConcept(1 + offset)">[CONCEPT ART]</div>
      </div>
      <div :key="2 + offset" class="edge" @click="enterFullscreen(2)">
        <img
          :src="getImage(2 + offset)"
          :style="imageStyles[5]"
          :class="transitionClass"
          draggable="false"
        />
        <div :class="concept" style="font-size: 1vw" v-if="isConcept(2 + offset)">[CONCEPT ART]</div>
      </div>
      <div :key="3 + offset" class="offscreen">
        <img
          :src="getImage(3 + offset)"
          :style="imageStyles[6]"
          :class="transitionClass"
          draggable="false"
        />
      </div>
    </transition-group>
    <!-- Pagination Controls -->
    <div class="pagination text-glow" v-if="pagination">
      <div class="nav" @click="decreaseCarousel(1)">«</div>
      <div class="dots">
        <div
          v-for="(x,i) in Array(pages)"
          :key="i"
          class="dot"
          :class="dotClass(i)"
          @click="setOffsetFromPage(i)"
        >•</div>
      </div>
      <div class="nav" @click="increaseCarousel(1)">»</div>
    </div>
  </div>
</template>

<script>
/**
 * A dope-ass homebrew carousel with infinite scroll and cool animations >:)
 */
import AsyncUtils from "@/scripts/utils/async"
import store from "@/store"
import { mapState } from "vuex"
export default {
  props: {
    pictures: {
      type: Array,
      default: () => []
    },
    centerHover: {
      type: Boolean,
      default: true
    },
    pagination: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      offset: 0,
      targetOffset: 0,
      seeking: false,
      hover: false,
      touchControl: {
        touching: false,
        start: -1,
        x: 0,
        percentage: 0,
        index: 0,
        transition: false
      },
      // this is useful in desktop to prevent it from moving while doing setIndex
      forceNoTransition: false,
      disableClick: false,
      disableHover: false
    }
  },
  watch: {
    /**
     * When the offset changes we allow a small animation buffer
     * This allows us to show clean consistent animation when
     * moving large distances via pagination
     */
    async targetOffset() {
      // already started going or already there
      if (this.seeking || this.offset === this.targetOffset) return
      this.seeking = true

      // keep going until its equal
      while (this.offset != this.targetOffset) {
        if (this.offset < this.targetOffset) {
          this.offset++
        } else if (this.offset > this.targetOffset) {
          this.offset--
        }
        await AsyncUtils.Sleep(100)
      }
      // Add delay to finish animation
      this.seeking = false
    },
    offset() {
      this.$emit("change", this.currentPage)
    }
  },
  computed: {
    /**
     * How many pages we have
     * NOTE: Right now pages === pictures
     */
    pages() {
      return this.pictures.length
    },
    /**
     * Based on offsets sets which "page" we are on
     */
    currentPage() {
      return this.getPage(this.offset)
    },
    /**
     * returns the selected picture for fullscreen
     */
    selectedPicture() {
      return this.getPage(this.targetOffset)
    },
    hoverClass() {
      return {
        ...this.transitionClass,
        "force-hover":
          ((this.fullscreen.enabled && this.fullscreen.id === "carousel") ||
            (this.hover && !this.disableHover)) &&
          this.centerHover
      }
    },
    ...mapState({
      fullscreen: state => state.projectSynthecite.fullscreen,
      touchEnabled: state => state.touchEnabled
    }),
    imageStyles() {
      let width = document.documentElement.clientWidth
      let x = this.touchControl.x / (width / 4)
      let values = [0, 0.5, 0.75, 1, 0.75, 0.5, 0]
      let per = val => op(val) * 100 + "%"
      let op = index => {
        // going back
        let val = values[index]
        let range = 1
        if (x < 0) {
          let prev = index == 0 ? 0 : index - 1
          range = Math.abs(values[index] - values[prev])
        } else if (x > 0) {
          let next = index === values.length - 1 ? index : index + 1
          range = Math.abs(values[index] - values[next])
        }
        let newX = x * range
        if (index < 3) {
          val += newX
        } else if (index == 3) {
          if (x < 0) {
            val += newX
          } else {
            val -= newX
          }
        } else {
          val -= newX
        }
        return Math.max(0, Math.min(1, val))
      }

      // NOTE: Use max-height instead of height, as we have a screen size constraint
      // Found only in mobile but used everywhere (max-width:100vw & height:auto solves this)
      let offL = {
        "max-height": per(0),
        opacity: op(0)
      }
      let edgeL = {
        "max-height": per(1),
        opacity: op(1)
      }
      let edgeCenterL = {
        "max-height": per(2),
        opacity: op(2)
      }
      let center = {
        "max-height": per(3),
        opacity: op(3)
      }
      let edgeCenterR = {
        "max-height": per(4),
        opacity: op(4)
      }
      let edgeR = {
        "max-height": per(5),
        opacity: op(5)
      }
      let offR = {
        "max-height": per(6),
        opacity: op(6)
      }
      return [offL, edgeL, edgeCenterL, center, edgeCenterR, edgeR, offR]
    },
    transitionClass() {
      return {
        transition: !this.forceNoTransition
      }
    },
    concept() {
      return this.fullscreen.enabled ? "concept fullscreen" : "concept"
    }
  },
  created() {
    // put it in the middle why not
    this.offset = Math.floor(this.pictures.length / 2)
    this.targetOffset = this.offset
  },
  methods: {
    // Sets the hover for the center image
    setHover(set) {
      // if seeking dont set
      if (this.seeking && this.hover) {
        return
      }
      this.hover = set
    },
    // helper for getting current page
    getPage(offset) {
      let page = offset
      if (page < 0) {
        page = -page % this.pictures.length
        if (page !== 0) {
          page = this.pictures.length - page
        }
      } else {
        page = page % this.pictures.length
      }
      return page
    },
    /**
     * Gets the image based on the offset
     */
    getImage(i) {
      if (i < 0) {
        i = -i % this.pictures.length
        if (i !== 0) {
          i = this.pictures.length - i
        }
      } else {
        i = i % this.pictures.length
      }
      return require("@/assets/project-synthecite/" + this.pictures[i])
    },
    /**
     * Goes forward a val
     */
    increaseCarousel(val) {
      this.forceNoTransition = false
      this.targetOffset += val
    },
    /**
     * Goes back a val
     */
    decreaseCarousel(val) {
      this.forceNoTransition = false
      this.targetOffset -= val
    },
    /**
     * Manually sets the index
     */
    setIndex(index) {
      this.forceNoTransition = true
      this.offset = index
      this.targetOffset = index

      // we dont want it transitioning when we manually set
      // next tick is NEEDED
      this.$nextTick(() => {
        this.forceNoTransition = false
      })
    },
    /**
     * If this page is the selected one
     */
    dotClass(page) {
      return this.currentPage === page ? "selected" : ""
    },
    /**
     * Sets the offset based on the pagination control
     */
    setOffsetFromPage(page) {
      this.targetOffset += page - this.currentPage
    },

    /**
     * Full screen image viewer
     */
    async enterFullscreen(val) {
      // event stop
      if (this.disableClick) {
        return
      }
      if (val < 0) {
        this.decreaseCarousel(-val)
      } else if (val > 0) {
        this.increaseCarousel(val)
      } else {
        // cant do in the middle of transitions
        if (this.seeking) {
          return
        }
        store.commit("setFullscreen", {
          enabled: true,
          pictures: this.pictures,
          id: "carousel",
          selectedIndex: this.selectedPicture
        })
      }
    },
    setStartPosition(e) {
      this.disableClick = false

      // mouse or touch
      this.touchControl.start = e.clientX || e.targetTouches[0].clientX
      this.touchControl.percentage = 0
      this.touchControl.touching = true
    },
    setEndPosition() {
      this.forceNoTransition = false
      this.disableHover = false
      this.touchControl.start = 0
      this.touchControl.touching = false
      let leeway = 0.15
      if (Math.abs(this.touchControl.percentage) > leeway) {
        this.disableClick = true
        if (this.touchControl.percentage > 0) {
          this.offset--
          this.targetOffset--
        } else {
          this.offset++
          this.targetOffset++
        }
      } else {
        this.disableClick = this.disableClick || false
      }
      this.touchControl.x = 0
    },
    touchMovingHandler(e) {
      if (!this.touchControl.touching) {
        return
      }
      // mouse or touch
      let x = e.clientX || e.targetTouches[0].clientX

      // find offset
      let offset = x - this.touchControl.start
      let per = offset / (document.documentElement.clientWidth / 2)
      let resetTouch = () => {
        this.touchControl.x = 0
        this.touchControl.percentage = 0
        this.touchControl.start = x

        // if we have changed, no touch events
        this.disableClick = true
      }

      // if the center ever becomes a side (75%) reset and increase/decrease order
      let centerHeight = parseInt(this.imageStyles[3]["max-height"])
      let past = centerHeight <= 75
      if (past && per > 0) {
        this.offset--
        this.targetOffset--
        resetTouch()
      } else if (past && per < 0) {
        this.offset++
        this.targetOffset++
        resetTouch()
      } else {
        const scrollLeeway = 0.1
        // This is to allow users to still be able to use this as an anchor for page scrolling
        // makes swiping clean af
        if (Math.abs(per) >= scrollLeeway || !this.touchEnabled) {
          this.touchControl.x = offset
          this.touchControl.percentage = per
          this.forceNoTransition = true
          this.disableHover = true
        }
      }
    },
    isConcept(index) {
      return this.getImage(index).includes("CONCEPT")
    },
  }
}
</script>

<style scoped lang="scss">
@import "@/views/project-synthecite/styles/variables.scss";

.carousel {
  position: relative;
  overflow: visible;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
}
.image-container {
  height: 100%;
  width: 90%;
  display: flex;
  justify-content: center;
  padding: 10px;
  filter: drop-shadow(0px 0px 5px rgba($green, 0.4));
  animation: 10s glowContainer ease infinite;
}
@keyframes glowContainer {
  0%,
  100% {
    filter: drop-shadow(0px 0px 5px rgba($green, 0.4));
  }
  50% {
    filter: drop-shadow(0px 0px 5px rgba($green, 0.1));
  }
}
.pagination {
  display: flex;
  font-size: 40px;
  margin-top: 20px;
}
.dots {
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
}

.dots .dot {
  padding-left: 10px;
  padding-right: 10px;
}

@media only screen and (max-width: 400px) {
  .dots .dot {
    padding-left: 5px;
    padding-right: 5px;
  }
}
@media only screen and (max-width: 500px) {
  .dots {
    margin-left: 10px;
    margin-right: 10px;
  }
}

.dots .dot,
.pagination .nav {
  transition: 0.2s all;
  cursor: pointer;
}

.dots .dot:hover,
.pagination .nav:hover {
  color: rgba($green, 0.5);
}
.dots .dot.selected {
  color: rgba($green, 0.8);
}
.center,
.center-edge,
.edge,
.offscreen {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.center img.transition,
.center-edge img.transition,
.edge img.transition,
.offscreen img.transition {
  transition: 0.2s all linear;
}
.center img.force-hover {
  // Important!
  max-height: 110% !important;
  height: 110%;
}
img {
  cursor: pointer;
  border-radius: 5px;
  // Prevent the images from being larger than the viewport
  height: auto;
  max-width: 100vw;
}

.center-edge img {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.center + .center-edge img {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.edge-edge img {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.center-edge + .edge img {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
.concept {
  color: $text-color;
  font-size: 1.5vw;
  width:100%;
  text-align: center;
  opacity: 0.25;
  box-shadow: none;
  transition: 0.5s font-size;
}
.concept.fullscreen  {
  font-size: 2vw;
}
</style>